import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import Footer from '../../components/Footer';

const DIAS = [
    { value: 1, label: 'S' },
    { value: 2, label: 'T' },
    { value: 3, label: 'Q' },
    { value: 4, label: 'Q' },
    { value: 5, label: 'S' },
];

const DIAS_FULL = ['', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex'];

const today = new Date().toISOString().split('T')[0];

const EscalasTerapeutas = () => {
    const { showNotification } = useNotification();
    const [terapeutas, setTerapeutas] = useState([]);
    const [schedules, setSchedules] = useState([]);  // todos os slots
    const [upcomingBlocks, setUpcomingBlocks] = useState([]);  // todos os bloqueios futuros
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            authFetch('therapist').then(r => r.json()),
            authFetch('therapist-schedule').then(r => r.json()),
            authFetch('therapist-schedule/blocks/upcoming').then(r => r.json()),
        ])
            .then(([teraps, slots, blocks]) => {
                setTerapeutas(teraps.filter(t => !t.disabled));
                setSchedules(slots);
                setUpcomingBlocks(blocks);
            })
            .catch(() => showNotification('danger', 'Erro ao carregar escalas'))
            .finally(() => setLoading(false));
    }, []);

    // Slots por terapeuta: Map<therapistId, Set<"day-shift">>
    const slotsByTherapist = schedules.reduce((acc, s) => {
        if (!acc[s.therapistId]) acc[s.therapistId] = new Set();
        acc[s.therapistId].add(`${s.dayOfWeek}-${s.shift}`);
        return acc;
    }, {});

    // Bloqueios futuros por terapeuta: Map<therapistId, TherapistScheduleBlock[]>
    const blocksByTherapist = upcomingBlocks.reduce((acc, b) => {
        if (!acc[b.therapistId]) acc[b.therapistId] = [];
        acc[b.therapistId].push(b);
        return acc;
    }, {});

    const hasSchedule = (id) => slotsByTherapist[id] && slotsByTherapist[id].size > 0;

    // Resumo textual da escala: "Seg+Qua Manhã · Ter+Qui+Sex Tarde"
    const scheduleResumo = (id) => {
        const slots = slotsByTherapist[id];
        if (!slots || slots.size === 0) return null;

        const manha = [...slots]
            .filter(k => k.endsWith('-0'))
            .map(k => DIAS_FULL[parseInt(k)])
            .join('+');
        const tarde = [...slots]
            .filter(k => k.endsWith('-1'))
            .map(k => DIAS_FULL[parseInt(k)])
            .join('+');

        const partes = [];
        if (manha) partes.push(`${manha} Manhã`);
        if (tarde) partes.push(`${tarde} Tarde`);
        return partes.join(' · ');
    };

    return (
        <div className="content">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="font-weight-bolder mb-0">Escala de Trabalho</h3>
                <div className="d-flex gap-3">
                    <div className="d-flex align-items-center gap-1">
                        <div className="rounded" style={{ width: 14, height: 14, background: '#86efac' }}></div>
                        <span className="text-xs text-secondary">Manhã</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="rounded" style={{ width: 14, height: 14, background: '#16a34a' }}></div>
                        <span className="text-xs text-secondary">Tarde</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="rounded" style={{ width: 14, height: 14, background: '#3b82f6' }}></div>
                        <span className="text-xs text-secondary">Manhã e Tarde</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="rounded" style={{ width: 14, height: 14, background: '#e5e7eb', opacity: 0.3 }}></div>
                        <span className="text-xs text-secondary">Não trabalha</span>
                    </div>
                </div>
            </div>

            <div className="card mb-4">
                <div className="card-body p-3">
                    {loading ? (
                        <p className="text-sm text-secondary">Carregando...</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Terapeuta</th>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Escala Semanal
                                        </th>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                                            Bloqueios
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {terapeutas.map(t => {
                                        const slots = slotsByTherapist[t.id] || new Set();
                                        const blocks = blocksByTherapist[t.id] || [];
                                        const resumo = scheduleResumo(t.id);

                                        return (
                                            <tr key={t.id}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        {t.color && (
                                                            <span
                                                                className="rounded-circle d-inline-block"
                                                                style={{ width: 10, height: 10, background: t.color, flexShrink: 0 }}
                                                            />
                                                        )}
                                                        <span className="text-sm font-weight-bold">{t.name}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    {!hasSchedule(t.id) ? (
                                                        <span className="text-xs text-secondary fst-italic">Não cadastrada</span>
                                                    ) : (
                                                        <div>
                                                            {/* Mini grid visual */}
                                                            <div className="d-flex gap-1 mb-1">
                                                                {DIAS.map(dia => {
                                                                    const manha = slots.has(`${dia.value}-0`);
                                                                    const tarde = slots.has(`${dia.value}-1`);
                                                                    const ambos = manha && tarde;
                                                                    return (
                                                                        <div key={dia.value} className="text-center" style={{ width: 28 }}>
                                                                            <div className="text-xxs text-secondary mb-1"
                                                                                style={{ fontSize: '0.6rem' }}>
                                                                                {DIAS_FULL[dia.value]}
                                                                            </div>
                                                                            <div className="rounded" style={{
                                                                                height: 22,
                                                                                background: ambos
                                                                                    ? '#3b82f6'
                                                                                    : manha
                                                                                        ? '#86efac'
                                                                                        : tarde
                                                                                            ? '#16a34a'
                                                                                            : '#e5e7eb',
                                                                                opacity: (!manha && !tarde) ? 0.3 : 1,
                                                                            }} />
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                            {/* Legenda resumo */}
                                                            {resumo && (
                                                                <div className="text-xxs text-secondary" style={{ fontSize: '0.65rem' }}>
                                                                    {resumo}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {blocks.length > 0 ? (
                                                        <span className="badge bg-danger" title={
                                                            blocks.map(b => {
                                                                const d = b.startDate === b.endDate
                                                                    ? b.startDate
                                                                    : `${b.startDate} – ${b.endDate}`;
                                                                return `${d}${b.reason ? ' (' + b.reason + ')' : ''}`;
                                                            }).join('\n')
                                                        }>
                                                            {blocks.length} bloqueio{blocks.length > 1 ? 's' : ''}
                                                        </span>
                                                    ) : (
                                                        <span className="text-secondary" style={{ fontSize: '0.7rem' }}>—</span>
                                                    )}
                                                </td>
                                                <td className="text-end">
                                                    <Link
                                                        to={`/Terapeutas/Escala/${t.id}`}
                                                        className="btn btn-sm btn-outline-primary py-1 px-2"
                                                        title="Gerenciar escala"
                                                    >
                                                        <i className="bi bi-pencil-square me-1"></i>
                                                        Gerenciar
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

<Footer />
        </div>
    );
};

export default EscalasTerapeutas;
